import { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { sendWa } from "@/lib/whatsapp";
import { waUrl } from "@/lib/contacts";
import { toast } from "sonner";
import { Mail, MessageCircle, CheckCircle2, ArrowRight } from "lucide-react";
import { niceName, fmtPhone } from "@/lib/format";

const card = "bg-white rounded-[16px] p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-slate-100";

function OwnerSend({ pid, link, i, onSent, tw }) {
  const [sent, setSent] = useState({});
  const send = async (channel) => {
    const viaTw = tw && channel === "whatsapp";
    const win = channel === "whatsapp" && !viaTw ? window.open("", "_blank") : null;
    try {
      const { data } = await api.post(`/processes/${pid}/portal-links/${link.token}/send`, { channel, base_url: window.location.origin });
      if (win) win.location.href = `${waUrl(link.phone)}?text=${encodeURIComponent(data.wa_text)}`;
      if (viaTw && !(await sendWa(pid, link.phone, data.wa_text))) return;
      setSent((s) => ({ ...s, [channel]: true }));
      onSent();
      if (channel === "email") toast.success(`Email enviado a ${niceName(link.name)}`);
    } catch (e) { if (win) win.close(); toast.error(apiErr(e.response?.data?.detail)); }
  };
  const btn = "inline-flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-semibold transition-colors";
  return (
    <div className="flex items-center justify-between gap-3 flex-wrap py-3 border-t border-slate-100 first:border-t-0" data-testid={`send-owner-${i}`}>
      <div>
        <div className="font-medium text-ec-green">{niceName(link.name)}</div>
        <div className="text-xs text-slate-500">{link.email} · {fmtPhone(link.phone)}</div>
      </div>
      <div className="flex gap-2 flex-wrap">
        <button onClick={() => send("email")} disabled={!link.email || sent.email} data-testid={`send-email-${i}`}
          className={`${btn} ${sent.email ? "bg-emerald-50 text-emerald-700 border border-emerald-200" : "bg-ec-green text-white hover:bg-ec-greenDark"}`}>
          {sent.email ? <CheckCircle2 size={15} /> : <Mail size={15} />} {sent.email ? "Email enviado" : "Enviar por email"}
        </button>
        <button onClick={() => send("whatsapp")} disabled={!link.phone} data-testid={`send-wa-${i}`}
          className={`${btn} ${sent.whatsapp ? "bg-emerald-50 text-emerald-700 border border-emerald-200" : "border border-slate-200 text-ec-green hover:bg-slate-50"}`}>
          {sent.whatsapp ? <CheckCircle2 size={15} /> : <MessageCircle size={15} />} {sent.whatsapp ? (tw ? "WhatsApp enviado" : "WhatsApp aberto") : "Enviar por WhatsApp"}
        </button>
      </div>
    </div>
  );
}

export function SendLinks({ c, onDone }) {
  const [any, setAny] = useState(false);
  const [tw, setTw] = useState(false);
  useEffect(() => { api.get("/agency/twilio-wa").then(({ data }) => setTw(!!data.enabled)).catch(() => {}); }, []);
  return (
    <div className="max-w-3xl space-y-6" data-testid="send-links">
      <div>
        <h1 className="font-heading text-3xl text-ec-green">Angariação {c.ref} criada</h1>
        <p className="text-slate-500 mt-1">Envie agora a página do cliente: o proprietário confirma os dados do contrato e envia os documentos pelo telemóvel.</p>
      </div>
      <div className={card}>{c.links.map((l, i) => <OwnerSend key={l.token} pid={c.id} link={l} i={i} tw={tw} onSent={() => setAny(true)} />)}</div>
      <button onClick={onDone} data-testid="send-links-done" className="inline-flex items-center gap-2 text-sm font-semibold text-ec-green hover:underline">
        {any ? "Ir para o processo" : "Enviar mais tarde"} <ArrowRight size={15} />
      </button>
    </div>
  );
}
